import resolveServiceWorkerContainer from './resolveServiceWorkerContainer';

export type UnregisterServiceWorkerOptions = {
	readonly container?: ServiceWorkerContainer;
};

/**
 * Cleans up a worker left over from serving a production build on a development origin: without
 * this, the stray worker keeps intercepting the dev server and the symptom is indiagnosable. A
 * failure here is swallowed for the same reason registration failures are: this is best-effort
 * housekeeping, never a condition the application startup depends on.
 */
const unregisterServiceWorker = (options: UnregisterServiceWorkerOptions = {}): void => {
	const container = options.container ?? resolveServiceWorkerContainer();

	if (!container) {
		return;
	}

	container
		.getRegistrations()
		.then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
		.catch(() => {
			// A stray worker that fails to unregister is retried on the next boot; it never blocks this one.
		});
};

export default unregisterServiceWorker;
